import { BsFillEyeFill } from 'react-icons/bs'
import { GiMultipleTargets } from 'react-icons/gi'
const aboutCardData = [
  {
    btnLink: '/about',
    icon: <GiMultipleTargets />,
    title: 'KATON VISION STATEMENT',
    text: 'To be a 360-degree learning hub for global leadership and lifestyle experience.',
  },
  {
    btnLink: '/about',
    icon: <BsFillEyeFill />,
    title: 'KATON MISSION STATEMENT',
    text: 'To empower knowledge through creativity in the global space.',
  },
]
export const aboutFeature = [
  {
    id: '1',
    title: 'Learning Hub',
  },
  {
    id: '2',
    title: 'Transformation',
  },
  {
    id: '3',
    title: 'Hands-on',
  },
  {
    id: '4',
    title: '24/7',
  },
]

export default aboutCardData
